import React from 'react';
import { Star } from 'lucide-react';
import { useScrollReveal } from './useScrollReveal';
const testimonials = [{
  quote: 'Llegué al día 5 sin Endo-Belly por primera vez en años. No lo podía creer.',
  author: 'Valentina M.',
  details: '31 años, Buenos Aires'
}, {
  quote: 'El Bonus del Botón de Pánico lo tengo pegado en la heladera. Me salvó dos crisis seguidas.',
  author: 'Lucía R.',
  details: '27 años, Córdoba'
}, {
  quote: 'Por fin algo que entiende que no puedo comprar semillas de chía importadas. Todo con lo que hay en el Coto de mi barrio.',
  author: 'Florencia D.',
  details: '35 años, Rosario'
}, {
  quote: 'Pude volver a trabajar sin tener que tomarme el día por el dolor. La desinflamación que logré en dos semanas es increíble.',
  author: 'Camila S.',
  details: '28 años, Mendoza'
}, {
  quote: 'El plan de comidas es súper fácil de seguir. Nada de ingredientes raros, todo lo compré en el súper de la esquina y me siento con más energía que nunca.',
  author: 'Martina L.',
  details: '33 años, Tucumán'
}];
export function TestimonialsSection() {
  const ref = useScrollReveal();
  return <section className="w-full bg-marfil py-16 px-5 flex justify-center" data-id="element-180">
      <div ref={ref} className="fade-up w-full max-w-md flex flex-col gap-8" data-id="element-181">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight text-center" data-id="element-182">
          Lo que dicen las mujeres que ya lo hicieron:
        </h2>
        <div className="flex flex-col gap-4" data-id="element-183">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border border-salvia-light flex flex-col gap-3" data-id="element-184">
              <div className="flex gap-1" data-id="element-185">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-186" />)}
              </div>
              <p className="text-gray-800 text-base font-medium leading-snug italic" data-id="element-187">
                "{t.quote}"
              </p>
              <div className="mt-1" data-id="element-188">
                <p className="font-bold text-petroleo text-sm" data-id="element-189">{t.author}</p>
                <p className="text-xs text-gray-500" data-id="element-190">{t.details}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}